import type { TableProduct } from '../types';

let copiedTableProducts: TableProduct[] | null = null;

export function setCopiedTableProducts(products: TableProduct[]): void {
  copiedTableProducts = products.map(product => ({ ...product }));
}

export function getCopiedTableProducts(): TableProduct[] | null {
  return copiedTableProducts ? copiedTableProducts.map(product => ({ ...product })) : null;
}

export function hasCopiedTableProducts(): boolean {
  return Boolean(copiedTableProducts && copiedTableProducts.length > 0);
}
